import { FileQuestion } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@mehir/web-ui/button';
import { Card, CardContent } from '@mehir/web-ui/card';

/**
 * Unknown paths used to be swallowed by a redirect to the dashboard, so a typo
 * or a stale bookmark looked like the panel had simply ignored the click.
 */
export const NotFound = () => {
  const { pathname } = useLocation();

  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 py-16 text-center">
          <FileQuestion className="h-12 w-12 text-muted-foreground" />
          <div>
            <h1 className="text-xl font-semibold">Sayfa bulunamadı</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              <code className="rounded bg-muted px-1.5 py-0.5 text-xs">{pathname}</code> adresinde
              bir sayfa yok. Bağlantı eski olabilir.
            </p>
          </div>
          <Link to="/">
            <Button variant="outline">Ana sayfaya dön</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};
